import * as swcHelpers from '@swc/helpers';

/**
 * Marks all the invalid fields in a form as touched.
 */ function markFormFieldsTouched(form) {
    return Object.entries(form).reduce((prev, [field, valueState])=>{
        if (!valueState) {
            return prev;
        }
        if (valueState.isValid) {
            return swcHelpers.objectSpread({}, prev, {
                [field]: valueState
            });
        }
        return swcHelpers.objectSpread({}, prev, {
            [field]: swcHelpers.objectSpread({}, valueState, {
                isTouched: true
            })
        });
    }, {});
}

export { markFormFieldsTouched };
//# sourceMappingURL=mark-fields-touched.js.map
